import { Pager, buildPager } from '@coveo/headless';
import headlessEngine from './headlessEngine';
import savedTrialHeadlessEnginee from './savedTrialHeadlessEngine';

export const getPager = (noOfPages = 6) => {
  const pager = buildPager(headlessEngine, { options: { numberOfPages: noOfPages } });
  return pager;
};

export const getSavedTrialsPager = (noOfPages = 12) => {
  const savedTrialsPager = buildPager(savedTrialHeadlessEnginee, {
    options: { numberOfPages: noOfPages },
  });
  return savedTrialsPager;
};

export const setPager = (pagerProps: Pager) => {
  pagerProps.selectPage(1);
};
